import Coverage from 'pages/benefits/coverage/Coverage';
import { CoveragePlan } from 'all-in-one-shared-api';

function Dental() {
  return <Coverage coveragePlan={CoveragePlan.DENTAL} />;
}

export default Dental;
